module.exports = __webpack_public_path__ + "static/media/04.5ccbdf15.webp";